define('features/overlayGameLauncher/adventureTwo/shop/ShopItemModel',[],function () {

    return function ShopItemModel (BuyShopItemCommand,
                                   playerId,
                                   rawItemData) {
        var self = this;

        self.name = rawItemData.name;
        self.priceInGems = rawItemData.priceInGems;
        self.image = '/images/shop-items/deposit.png';
        self.cmd = new BuyShopItemCommand({
            itemId: rawItemData.id,
            playerId: playerId
        });
    };

});

